import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "el-transfer-box"
};
import { getItemOrIngredApi, updateItemOrIngredApi } from "@/service/modules/scan";
import { ElMessage } from "element-plus";
import { ref, watch } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'small-eat',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    diseaseId: {
      type: Number,
      default: 1
    }
  },
  emits: ["closeDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const itemEat = ref([]);
    const itemNoEat = ref([]);
    const ingredEat = ref([]);
    const ingredNoEat = ref([]);
    function closeDialog() {
      emit("closeDialog");
    }
    async function updateItemOrIngred(currentValue, direction, movedValue, updateType) {
      let data = {
        diseaseId: props.diseaseId,
        edible: true,
        ids: [...movedValue],
        updateType,
        moderation: false
      };
      if (direction === "left") {
        data.moderation = false;
      } else {
        data.moderation = true;
      }
      try {
        await updateItemOrIngredApi(data);
        ElMessage.success("更新成功");
      } catch (error) {
        console.log("error", error);
      }
    }
    async function updateItem(currentValue, direction, movedValue) {
      await updateItemOrIngred(currentValue, direction, movedValue, 1);
    }
    async function updateIngred(currentValue, direction, movedValue) {
      await updateItemOrIngred(currentValue, direction, movedValue, 2);
    }
    async function getItemOrIngred() {
      try {
        //可食用物品
        let res = await getItemOrIngredApi({
          diseaseId: props.diseaseId,
          edible: true,
          moderation: false,
          type: 1
        });
        itemEat.value = [...itemEat.value, ...res.data.map(item => ({
          key: item.id,
          label: item.name
        }))];
      } catch (error) {}
      try {
        //少量食用物品
        let res = await getItemOrIngredApi({
          diseaseId: props.diseaseId,
          edible: true,
          moderation: true,
          type: 1
        });
        itemEat.value = [...itemEat.value, ...res.data.map(item => ({
          key: item.id,
          label: item.name
        }))];
        itemNoEat.value = res.data.map(item => item.id);
      } catch (error) {}
      //可食用成分
      try {
        let res = await getItemOrIngredApi({
          diseaseId: props.diseaseId,
          edible: true,
          moderation: false,
          type: 2
        });
        ingredEat.value = [...ingredEat.value, ...res.data.map(item => ({
          key: item.id,
          label: item.name
        }))];
      } catch (error) {}
      try {
        //可少量食用成分
        let res = await getItemOrIngredApi({
          diseaseId: props.diseaseId,
          edible: true,
          moderation: true,
          type: 2
        });
        ingredEat.value = [...ingredEat.value, ...res.data.map(item => ({
          key: item.id,
          label: item.name
        }))];
        ingredNoEat.value = res.data.map(item => item.id);
      } catch (error) {}
    }
    watch(() => props.dialogVisible, newVal => {
      if (newVal) {
        getItemOrIngred();
      } else {
        itemEat.value = [];
        itemNoEat.value = [];
        ingredEat.value = [];
        ingredNoEat.value = [];
      }
    });
    return (_ctx, _cache) => {
      const _component_el_transfer = _resolveComponent("el-transfer");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "",
        width: "1400px",
        onClose: closeDialog
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: closeDialog
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("关闭")])),
          _: 1
        })]),
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "el-transfer-title"
        }, [_createElementVNode("div", null, [_createElementVNode("h3", null, "选择物品")]), _createElementVNode("div", null, [_createElementVNode("h3", null, "选择成分")])], -1)), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_transfer, {
          modelValue: itemNoEat.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => itemNoEat.value = $event),
          data: itemEat.value,
          filterable: "",
          titles: ['可食用物品', '少量食用物品'],
          onChange: updateItem
        }, null, 8, ["modelValue", "data"]), _createVNode(_component_el_transfer, {
          modelValue: ingredNoEat.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ingredNoEat.value = $event),
          data: ingredEat.value,
          filterable: "",
          titles: ['可食用成分', '少量食用成分'],
          onChange: updateIngred
        }, null, 8, ["modelValue", "data"])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
});